import { CrusherTypes } from './CrusherConeCHTypes';
import type { CrusherDataMapInterface } from 'unitData/Crushers/BaseCrusherTypes';
import {
  CHCrusherGetMaxCSS,
  getBushings,
} from 'unitData/Crushers/CrusherConeCH/CrusherConeCHInfo';
import type {
  CrusherHighBinInterface,
  UnitInfoCrusherInterface,
} from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { ConeCrusherCHUnitInfoDataMapInterface } from './unitInfoData';
import { getDefaultData as getDefaultStorageData } from '../../Storage/StorageData';
import { UnitTypes } from '../../types';

export const ConeCrusherCHData: CrusherDataMapInterface = {
  [CrusherTypes.CH420]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [13, 16, 18, 20, 22, 25],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [13, 16, 18, 20, 22, 25],
      },
      M: {
        mantles: ['B', 'HC'],
        throws: [13, 16, 18, 20, 22, 25, 28],
      },
      MF: {
        mantles: ['B', 'HC'],
        throws: [13, 16, 18, 20, 22, 25, 28],
      },
      F: {
        mantles: ['A', 'B', 'HC'],
        throws: [13, 16, 18, 20, 22, 25, 28],
      },
      EF: {
        mantles: ['EF'],
        throws: [13, 16, 18, 20, 22, 25, 28],
      },
    },
  },
  [CrusherTypes.CH430]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB', 'OptiAggL'],
        throws: [16, 19, 22, 25, 29, 32, 34],
      },
      C: {
        mantles: ['A', 'B', 'FFB', 'OptiAggL'],
        throws: [16, 19, 22, 25, 29, 32, 34],
      },
      MC: {
        mantles: ['A', 'B', 'HC', 'FFB', 'OptiAggL'],
        throws: [16, 19, 22, 25, 29, 32, 34, 36],
      },
      M: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 19, 22, 25, 29, 32, 34, 36],
      },
      MF: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 19, 22, 25, 29, 32, 34, 36],
      },
      F: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 19, 22, 25, 29, 32, 34, 36],
      },
      EF: {
        mantles: ['EF'],
        throws: [16, 19, 22, 25, 29, 32, 34, 36],
      },
    },
  },
  [CrusherTypes.CH440]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFA', 'FFB', 'OptiAggL'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      C: {
        mantles: ['A', 'B', 'FFA', 'FFB', 'OptiAggL'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      MC: {
        mantles: ['A', 'B', 'HC', 'FFA', 'FFB', 'OptiAggL'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      M: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      MF: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      F: {
        mantles: ['A', 'B', 'HC', 'OptiAggS'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      EF: {
        mantles: ['EF'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
    },
  },
  [CrusherTypes.CH442]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFA', 'FFB'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      C: {
        mantles: ['A', 'B', 'FFA', 'FFB'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      MC: {
        mantles: ['A', 'B', 'HC', 'FFA', 'FFB'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      M: {
        mantles: ['A', 'B', 'HC'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      MF: {
        mantles: ['A', 'B', 'HC'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      F: {
        mantles: ['A', 'B', 'HC'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
      EF: {
        mantles: ['EF'],
        throws: [16, 20, 24, 28, 32, 36, 40, 44],
      },
    },
  },
  [CrusherTypes.CH660]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'D', 'FFB', 'OptiAggL'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      CX: {
        mantles: ['A', 'B', 'D', 'FFB', 'OptiAggL'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      C: {
        mantles: ['A', 'B', 'D', 'FFB', 'OptiAggL'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      MC: {
        mantles: ['A', 'B', 'D', 'HC', 'FFB', 'OptiAggL'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      M: {
        mantles: ['A', 'B', 'D', 'HC', 'OptiAggS'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      MF: {
        mantles: ['A', 'B', 'D', 'HC', 'OptiAggS'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      F: {
        mantles: ['A', 'B', 'D', 'HC', 'OptiAggS'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      EF: {
        mantles: ['EF'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
    },
  },
  [CrusherTypes.CH662]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      MC: {
        mantles: ['A', 'B', 'HC', 'FFB'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48],
      },
      M: {
        mantles: ['A', 'B', 'HC'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      MF: {
        mantles: ['A', 'B', 'HC'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      F: {
        mantles: ['A', 'B', 'HC'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
      EF: {
        mantles: ['EF'],
        throws: [18, 20, 24, 28, 32, 36, 40, 44, 48, 50],
      },
    },
  },
  [CrusherTypes.CH830i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52],
      },
      M: {
        mantles: ['A', 'B'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52],
      },
      F: {
        mantles: ['A', 'B'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52],
      },
      EF: {
        mantles: ['EF'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52],
      },
    },
  },
  [CrusherTypes.CH840i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
      MC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
      M: {
        mantles: ['A', 'B'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
      MF: {
        mantles: ['A', 'B'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
      F: {
        mantles: ['A', 'B'],
        throws: [28, 32, 36, 40, 44, 48, 52],
      },
    },
  },
  [CrusherTypes.CH860i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
      MC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
      M: {
        mantles: ['A', 'B'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
    },
  },
  [CrusherTypes.CH865i]: {
    concaves: {
      MF: {
        mantles: ['EF', 'OB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
      F: {
        mantles: ['EF', 'OB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
      EF: {
        mantles: ['EF', 'OB'],
        throws: [30, 34, 38, 42, 46, 50, 54, 58, 62, 66, 70],
      },
    },
  },
  [CrusherTypes.CH870i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      C: {
        mantles: ['A', 'B', 'FFB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      MC: {
        mantles: ['A', 'B', 'FFB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      M: {
        mantles: ['A', 'B'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      MF: {
        mantles: ['EF', 'OB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      F: {
        mantles: ['EF', 'OB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
      EF: {
        mantles: ['EF', 'OB'],
        throws: [32, 37, 42, 47, 52, 57, 62, 68, 74, 80],
      },
    },
  },
  [CrusherTypes.CH890i]: {
    concaves: {
      EC: {
        mantles: ['A', 'B', 'FFA'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      C: {
        mantles: ['A', 'B', 'FFA'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      MC: {
        mantles: ['A', 'B', 'HC', 'FFA'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      M: {
        mantles: ['A', 'B', 'HC'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      MF: {
        mantles: ['A', 'B', 'HC'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      F: {
        mantles: ['EF', 'OB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
    },
  },
  [CrusherTypes.CH895i]: {
    concaves: {
      EFX: {
        mantles: ['EF', 'OB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      EF: {
        mantles: ['EF', 'OB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
      EEF: {
        mantles: ['EF', 'OB'],
        throws: [24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 70],
      },
    },
  },
};

/**
 * Returns the default CrusherHighBin object
 */
export const getDefaultHighBinData = (): CrusherHighBinInterface => {
  const {
    feedInOut,
    inclinationRight,
    amountRight,
    feederOutputOptions,
    rightPanFeederModelName,
    otherModelRight,
    otherModelMaxCapacityRight,
    otherRightPanFeederModelName,
    mining,
    ulip,
    autoSelect,
  } = getDefaultStorageData(UnitTypes.STORAGE_FEEDER);

  return {
    useHighBin: false,
    feedInOut,
    inclinationRight,
    amountRight,
    feederOutputOptions,
    rightPanFeederModelName,
    otherModelRight,
    otherModelMaxCapacityRight,
    otherRightPanFeederModelName,
    mining,
    ulip,
    autoSelect,
  };
};

export class CrusherConeCHConfig extends BaseUnitConfig {
  static getDefaultData(params?: UnitConfigParams): UnitInfoCrusherInterface {
    const unitInfoData =
      (params?.data as ConeCrusherCHUnitInfoDataMapInterface | undefined) ?? {};

    const modelName = CrusherTypes.CH420;
    const concaveName = 'EC';
    const mantleName = ConeCrusherCHData[modelName].concaves['EC'].mantles[1];
    const unitThrow = ConeCrusherCHData[modelName].concaves['EC'].throws[2];
    const bushings = getBushings(modelName, concaveName, unitThrow);

    const maxCss = CHCrusherGetMaxCSS(
      modelName,
      mantleName,
      concaveName,
      unitThrow,
      unitInfoData,
    );

    return {
      modelName: modelName,
      concave: concaveName,
      mantle: mantleName,
      unitThrow: unitThrow,
      bushing: bushings.length ? bushings[0] : '',
      css: 20,
      ...BaseUnitConfig.getBaseDefaults(),
      maxCSS: maxCss,
      showCustomModel: false,
      highBin: getDefaultHighBinData(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayThrow: true,
        displayCss: true,
        displayMinLiveBin: true,
        displayConcave: true,
        displayMantle: true,
        displayBushing: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const crusherConeCHConfig = new CrusherConeCHConfig();
